import { analyticsSettingsSource } from 'app.constants';
import { BaseAnalyticsController } from '../base/BaseAnalyticsController';
export class DashboardController extends BaseAnalyticsController {
    constructor() {
        super(...arguments);
        this.settingsSource = analyticsSettingsSource;
    }
}
